export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-maneuver-instructions-1200-01ef83d36ec8f8f8a6453aebf674cf3b.png";